import { render, staticRenderFns } from "./VeJwTjSettingModal.vue?vue&type=template&id=779407d2"
import script from "./VeJwTjSettingModal.vue?vue&type=script&lang=js"
export * from "./VeJwTjSettingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports